import config from '@/config/config';

import Index from '@/pages/config/economic-sector/index.vue';
import List from '@/pages/config/economic-sector/list/list.vue';
import View from '@/pages/config/economic-sector/view/view.vue';
import New from '@/pages/config/economic-sector/new/new.vue';
import Edit from '@/pages/config/economic-sector/edit/edit.vue';

const modulePermission = config.modules.economicSector;

export default {
  path: '/economic-sector',
  name: 'economic-sector',
  component: Index,
  meta: {
    requiresAuth: true,
    modulePermission: modulePermission,
    requiresPermission: 'enabled_read',
  },
  children: [
    {
      path: 'list',
      name: 'economic-sector-list',
      component: List,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_read',
      },
    },
    {
      path: ':id',
      name: 'economic-sector-view',
      component: View,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_read',
      },
      props: true,
    },
    {
      path: 'new',
      name: 'economic-sector-new',
      component: New,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_create',
      },
    },
    {
      path: ':id/e',
      name: 'economic-sector-edit',
      component: Edit,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_edit',
      },
      props: true,
    },
  ],
};
